import { Language } from '../../lang/Language'

export class CantBetLessThanMaxError extends Error {
  constructor() {
    super(Language.strings.error.table.cantBetLessThanMax)
  }
}
